import { getSessionStorage, setSessionStorage } from '/@/utils/storage'

const getDefaultState = () => {
  return {
    routeTag: null
  }
}

const states = getDefaultState()

const mutations = {
  SET_TAG: (state, tag) => {
    state.routeTag = tag
  }
}

const actions = {
  getTag({ commit }) {
    const routeTag = getSessionStorage('routeTag') || []
    commit('SET_TAG', routeTag)
  },
  setTag({ commit }, tag) {
    const routeTag = getSessionStorage('routeTag') || []
    if (routeTag && routeTag.length > 0) {
      let exist = false
      routeTag.forEach((item) => {
        // 如果与缓存中的路由记录都不相同则添加
        if (item.path === tag.path) {
          exist = true
        }
      })
      if (!exist) {
        routeTag.push(tag)
        setSessionStorage('routeTag', routeTag)
      }
    } else {
      tag && routeTag.push(tag)
      setSessionStorage('routeTag', routeTag)
    }
    commit('SET_TAG', routeTag)
  },
  removeTag({ commit }, tag) {
    const routeTag = getSessionStorage('routeTag') || []
    commit('SET_TAG', routeTag)
    routeTag.forEach((item, index) => {
      if (item.fullPath === tag.fullPath) {
        routeTag.splice(index, 1)
      }
    })
    setSessionStorage('routeTag', routeTag)
    commit('SET_TAG', routeTag)
  }
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions
}
